module.exports = __webpack_public_path__ + "static/media/relaxed.3df2cf7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/website/features/testimony/relaxed.jpg
// module id = 992
// module chunks = 0